module.exports = __webpack_public_path__ + "static/img/complaint_detail_1.fb1e5ed9.svg";